import { useQuery } from "react-query";
import { getAccountProperties } from "../services";

export const useAccountProperties = (accountNumber: string | number) => {
  return useQuery(
    ["accounts/properties", accountNumber],
    getAccountProperties,
    { enabled: !!accountNumber },
  );
};
